import { render, staticRenderFns } from "./vorgang-verlinkung-repru.vue?vue&type=template&id=67f0af88"
import script from "./vorgang-verlinkung-repru.vue?vue&type=script&lang=js"
export * from "./vorgang-verlinkung-repru.vue?vue&type=script&lang=js"
import style0 from "./vorgang-verlinkung-repru.vue?vue&type=style&index=0&id=67f0af88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports